import { render } from "./Blob.vue?vue&type=template&id=62915398&scoped=true"
import script from "./Blob.vue?vue&type=script&lang=js"
export * from "./Blob.vue?vue&type=script&lang=js"

import "./Blob.vue?vue&type=style&index=0&id=62915398&scoped=true&lang=scss"
import "./Blob.vue?vue&type=style&index=1&id=62915398&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62915398"]])

export default __exports__